export default "__VITE_ASSET__Bg7M1JNx__"